import BaseChip from '@material-ui/core/Chip'

const Chip = BaseChip

export default Chip
